export default __webpack_public_path__ + "static/media/profile.d39129a2.svg";